import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateListingPageComponent } from './components/page/create-listing-page.component';
import { AuthGuard } from '../../_guards';

const routes: Routes = [

    {
      path: ':id',
      component: CreateListingPageComponent,
      canActivate: [AuthGuard]
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CreateListingRoutingModule { }
